import { CDN_LINK } from "@globalConfig";

export const servicesData = (t) => {
  return [
    {
      title: t("سهولة شراء سيارتك أونلاين من جوالك ", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services5.webp",
      revRow: true,
      content: [
        {
          text: t(
            'إذا كنت ترغب في شراء سيارتك بكل سهولة ويسر، فنحن نوفر لك هذه الفرصة من خلال موقعنا وتطبيقنا "سيارة". فمن خلال النقر على زر واحد، يمكنك الآن اختيار السيارة التي تفضلها وحزها ودفع عربون بسيط يتم خصمه من قيمة السيارة، وإتمام باقي الإجراءات بكل سهولة وفي أسرع وقت ممكن.',
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("إتمام كافة إجراءات شراء السيارة عنك وبدون جهد ", {
        ns: "web_services",
      }),
      image: CDN_LINK + "/assets/images/services1.webp",
      revRow: false,
      content: [
        {
          text: t(
            'عند شراء سيارتك من خلال تطبيق "سيارة"، سيقوم فريق من المختصين بكافة الإجراءات اللازمة لنقل ملكية السيارة وتأمينها وضمانها بسرعة وسهولة. يتمتع فريقنا بخبرة عالية في هذا المجال، مما يسمح لك بتجنب أي تعقيدات أو صعوبات مرتبطة بعملية شراء السيارة. وبفضل هذه الخدمة الشاملة، ستوفر وقتك وجهدك وستتمكن من إتمام كافة الإجراءات على أكمل وجه، دون الحاجة إلى القيام بأي شيء. لذلك، يمكنك الاعتماد على تطبيق "سيارة" لشراء سيارتك بكل ثقة وأمان.',
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("سيارتك تصلك إلى باب بيتك ", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services6.webp",
      revRow: true,
      content: [
        {
          text: t(
            "يوفر تطبيق سيارة خدمة الشحن المنزلي للسيارات باستخدام سطحات حديثة مخصصة، وذلك لتوفير أقصى درجات الراحة والسهولة لعملائنا، حيث يمكن شحن السيارة المرغوبة إلى أي مكان داخل حدود المملكة العربية السعودية بكل يسر وسرعة.",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("طرق دفع إلكترونية آمنة", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services8.webp",
      revRow: false,
      content: [
        {
          text: t(
            "يقدم تطبيق سيارة خدمات دفع الكترونية آمنة وموثوقة، لتسهيل عملية دفع العربون أو ثمن السيارة بكل يسر وسهولة. يمكنك استخدام خدمة سداد أو العديد من القنوات الأخرى المتاحة لدينا لتأمين عملية الدفع بشكل مضمون وفعال.",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("تمويل وتقسيط سيارتك", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services4.webp",
      revRow: true,
      content: [
        {
          text: t(
            "تتيح شركة سيارة تقديم تسهيلات دفع لعملائها من خلال عدة جهات تمويل معتمدة في المملكة، حيث يمكن تقسيط ثمن السيارة على سنوات متعددة، مما يوفر للعملاء الراحة والتسهيل في عملية شراء السيارة التي يرغبون فيها.",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("فحص السيارة بأكثر من 200 نقطة", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services9.webp",
      revRow: false,
      content: [
        {
          text: t(
            "تهتم شركة سيارة بسلامة السيارات المستعملة وجودتها. لذا، تعمل على فحص كل سيارة بدقة عالية من خلال فريق خبراء ومختصين في هذا المجال. يتم فحص السيارة بأكثر من 200 نقطة للتأكد من سلامة المحرك وقطع السيارة الداخلية والخارجية. وتتيح الشركة عرض نتائج الفحص بشكل تفصيلي للعملاء والباحثين، حيث يمكنهم الاطلاع على كافة نقاط الفحص بشكل شامل وكامل، وذلك لتوفير الأمان والثقة على الطريق.",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("تجربة السيارة 10 أيام", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services2.webp",
      revRow: true,
      content: [
        {
          text: t(
            "تقدم شركة سيارة تجربة السيارة المستعملة لمدة 10 أيام، مما يتيح للعملاء فرصة الحصول على تجربة حقيقية للمركبة قبل الشراء، وذلك لضمان راحتهم وثقتهم في السيارة التي يختارونها. وإذا لم تكن المركبة تلبي توقعات العميل أو إذا كان هناك أي سبب آخر، فإنه يمكنهم إرجاعها بسهولة دون أي مشكلة.",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("تجهيز السيارات المستعملة", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services3.webp",
      revRow: false,
      content: [
        {
          text: t(
            "تحرص شركة سيارة على عمل  صيانة شاملة للسيارة، بما يشمل صيانة داخلية وخارجية وصيانة ميكانيكية في مراكزها المختصة. ويتم ذلك من خلال مهندسين وخبراء على مستوى عالي من الكفاءة والخبرة، الذين يجهزون السيارة ويصلحونها وفقًا لأعلى معايير الأمن والسلامة والجودة العالية.",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
    {
      title: t("ضمان حتى 3 سنوات", { ns: "web_services" }),
      image: CDN_LINK + "/assets/images/services7.webp",
      revRow: true,
      content: [
        {
          text: t("شركة سيارة توفر ضمانًا لمدة 6 أشهر مع إمكانية ترقية الضمان حتى 3 سنوات برسوم إضافية على السيارات المباعة، وذلك يتضمن إمكانية إصلاح وتغيير قطع الغيار المعيبة بالإضافة إلى توفير المساعدة على الطريق في حالة وقوع أي عطل أو حادث.",
            { ns: "web_services" }
          ),
          isBulltet: false,
        },
      ],
    },
  ];
};
